/**
 * @file The display label of every receivable aging bucket, keyed by
 * `AnalyticsAgingBucket`, in the design's copy with en dashes. Consumers: the
 * Receivable aging chart's bar rows, the Invoicing tab's invoice table and the
 * report run renderers in React and the PDF. The `Record` type fails the build
 * when a bucket is added without a label. A stored report run's retired
 * buckets read `ANALYTICS_RETIRED_AGING_BUCKET_LABELS` instead.
 */
import type { AnalyticsAgingBucket } from './Analytics.NamedQuery.types';

export const ANALYTICS_AGING_BUCKET_LABELS: Record<AnalyticsAgingBucket, string> = {
  days0To30: 'Current — 0–30 days',
  days31To60: '31–60 days',
  days61To90: '61–90 days',
  daysOver90: '90+ days',
};
